import React, { useState } from "react";
import { styles } from "./CsdrView.styles";
import { CssBaseline, Grid, Paper, Typography, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { FormDateField } from "../components/FormComponents/FormDateField";
import { FormTextField } from "../components/FormComponents/FormTextField";
import { CenteredContainer } from "../components/CenteredContainer/CenteredContainer";
import { DATE_FORMAT } from "../../constants/TIME";
import moment from "moment";
import { BlueButton } from "../components/Buttons/BlueButton";

export interface ICsdrViewProps extends WithStyles<typeof styles> {

}

const CsdrViewPure: React.FunctionComponent<ICsdrViewProps> = ({classes}: ICsdrViewProps) => {

    const [input, setInput] = useState({
        date: moment().format(DATE_FORMAT),
        isin: ""
    })

    const onDateChange = newDate => {
        setInput({
            ...input,
            date: newDate,
        });
        // trigger endpoint tbd
    }

    const onIsinChange = event => {
        setInput({
            ...input,
            isin: event.target.value,
        });
        // trigger endpoint tbd
    }

    const onExecute = () => {
        console.log(input);
        // trigger endpoint tbd
    }

    return <CenteredContainer>
        <CssBaseline />
        <div className={classes.title}>
            <Typography variant="h2">CSDR</Typography>
            <Typography variant="body1">In blandit velit quis est maximus, eget venenatis dolor luctus. Integer et lectus dapibus,
                auctor mauris et, mattis risus. Aenean euismod magna ut finibus sagittis. Curabitur posuere bibendum sagittis.
                Maecenas vel lorem eu felis consectetur viverra. Donec auctor iaculis urna, nec dignissim purus. Nunc viverra vel
                diam vestibulum porta. Sed rutrum quam id accumsan sodales. Nullam sollicitudin felis at mi finibus, sed viverra
                erat molestie. Ut aliquam nisi a ipsum venenatis auctor nec nec nunc. Vivamus lacinia elit dictum dolor congue
                mattis. Phasellus ut rhoncus tortor, at egestas risus. Curabitur sed ipsum ut sem pellentesque sagittis. Sed
                posuere porta felis in feugiat.</Typography>
        </div>
        <Paper className={classes.background}>
            <Grid container spacing={1}>

                <Grid item xs={12}>
                    <Typography variant="h3">Select date</Typography>
                </Grid>
                <Grid item xs={6}>
                    <FormDateField
                        label="Date"
                        variant="filled"
                        placeholder={"Date"}
                        disabled={false}
                        value={input.date}
                        onChange={onDateChange}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h3">Select ISIN</Typography>
                </Grid>
                <Grid item xs={8}>
                    <FormTextField
                        label={"ISIN"}
                        value={input.isin}
                        onChange={onIsinChange}
                    />

                </Grid>
                <Grid item xs={12}>
                    <BlueButton
                        onClick={onExecute}
                    >Execute</BlueButton>
                </Grid>
            </Grid>

        </Paper>


    </CenteredContainer>;
};

export const CsdrView = withStyles(styles)(CsdrViewPure);